import { connect } from "react-redux";
import Component from "./Stock";

export default connect(
    null,
    ({ scp: { Stock }, alert: { silence } }) => ({ Stock, silence })
)(Component);
